import { createContext } from 'react';

const ContactContext = createContext({
	contacts: [],
	setContacts: () => {},
});
export default ContactContext;
